import { render } from "./BtnConfirm.vue?vue&type=template&id=8d07467a"
import script from "./BtnConfirm.vue?vue&type=script&lang=js"
export * from "./BtnConfirm.vue?vue&type=script&lang=js"
script.render = render

export default script